import { ReactNode, useMemo } from "react";
import { numberFormat, round } from "shared/util"

import {
  Stack, Typography,
  LinearProgress,
  ListItem, ListItemButton, ListItemProps
} from "@mui/material";

type ListRecordWithBarProps = {
  index: number;
  code: string;
  name: string;
  count: number;
  max: number;
  isTarget?: boolean;
  selected?: boolean;
  onClicked: (code: string, name: string) => void;
  icon?: ReactNode;
} & ListItemProps
export const ListRecordWithBar = ({
  index,
  code,
  name,
  count,
  max,
  isTarget,
  selected,
  onClicked,
  icon,
  ...others
}: ListRecordWithBarProps) => {
  const fontSize = useMemo(
    () => (index === 0) ? "100%" : (index < 3) ? "90%" : (index < 5) ? "75%" : "60%",
    [index]
  )
  return (
    <ListItem disablePadding {...others}>
      <ListItemButton
        selected={selected}
        sx={{ display: 'block', paddingY: 0.3, paddingX: 2 }}
        onClick={(ev) => {
          if (!ev.defaultPrevented) {
            onClicked(code, name)
          }
        }}
      >
        <Stack direction="column">
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography
              variant="body2"
              component="div"
              color="text.primary"
              sx={{
                textAlign: 'left',
                flexGrow: 1,
                fontSize: {fontSize},
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >{name}</Typography>
            <Typography
              variant="body2"
              component="div"
              color="text.secondary"
              sx={{
                textAlign: 'right',
                fontSize: {fontSize},
                whiteSpace: 'nowrap'
              }}
            >{numberFormat(round(count, 1))} 人</Typography>
            {icon}
          </Stack>

          { max > 0 ? <LinearProgress
            variant="determinate" 
            value={(count * 100) / max}
            color={ isTarget ? 'error' : 'primary' }
            sx={{
              width: '100%',
              height: 5,
              borderRadius: 3
            }}
          /> : <></> }
        </Stack>
      </ListItemButton>
    </ListItem>
  );
}